export const LIST_ITEM_SIZE = {
    SMALL: 'small',
    LARGE: 'large',
};
export const LIST_ITEM_MODE = {
    DEFAULT: 'default',
    CHECK: 'check',
    BADGE: 'badge',
};
